import React, { useEffect, useRef, useState } from 'react';
import { strings } from '../constants/strings';
import { colors } from '../constants/colors';
import { ArrowRight } from 'lucide-react';

const HowItWorks = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section id="how-it-works" className="section-padding how-it-works-section" ref={sectionRef}>
      <div className="container">
        <div className={`section-header ${isVisible ? 'fade-in-up' : ''}`}>
          <h2 className="section-title">{strings.howItWorks.title}</h2>
        </div>
        
        <div className="steps-container">
          {strings.howItWorks.steps.map((step, index) => (
            <React.Fragment key={index}>
              <div 
                className={`step-item ${isVisible ? 'pop-in' : ''}`}
                style={{ animationDelay: `${index * 0.2}s` }}
              >
                <div className="step-number">{index + 1}</div>
                <div className="step-text">{step}</div>
              </div>
              
              {index < strings.howItWorks.steps.length - 1 && (
                <div 
                  className={`step-arrow ${isVisible ? 'fade-in' : ''}`}
                  style={{ animationDelay: `${index * 0.2 + 0.1}s` }}
                >
                  <ArrowRight size={24} style={{ color: colors.accent }} />
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
        
        <div className={`tagline ${isVisible ? 'fade-in-up' : ''}`} style={{ animationDelay: '0.8s' }}>
          <div className="tagline-decoration"></div>
          <p>{strings.howItWorks.tagline}</p>
          <div className="tagline-decoration"></div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
